import React, { useState } from 'react';
import type { TextFieldProps } from '@mui/material/TextField';

import IconButton from '@src/shared/ui/Button/IconButton';
import { EyeIcon, EyeOffIcon } from '@src/shared/ui/icons';
import InputAdornment from '@src/shared/ui/inputs/InputAdornment';
import TextInput from './TextInput';

const PasswordField = React.forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) => {
    const { slotProps, ...restProps } = props;

    const [visible, setVisible] = useState(false);

    const handleTogglePasswordVisibility = () => {
      setVisible((current) => !current);
    };

    const handleMouseDownPassword = (event: React.MouseEvent) => {
      event.preventDefault();
    };

    return (
      <TextInput
        autoComplete="new-password"
        {...restProps}
        ref={ref}
        type={visible ? 'text' : 'password'}
        slotProps={{
          ...slotProps,
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  size="small"
                  aria-label="toggle password visibility"
                  onMouseDown={handleMouseDownPassword}
                  onClick={handleTogglePasswordVisibility}
                >
                  {visible ? (
                    <EyeIcon sx={{ fontSize: 18 }} />
                  ) : (
                    <EyeOffIcon
                      sx={{ fontSize: 18 }}
                    />
                  )}
                </IconButton>
              </InputAdornment>
            ),
            ...(slotProps?.input as Record<string, unknown>),
          },
        }}
      />
    );
  },
);

PasswordField.displayName = 'PasswordField';
export default PasswordField;
